export default "__VITE_ASSET__DgocanSP__"